import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";

const getWidgetComponent = (type: string) => {
    return (fields => createWidgetElement(type, { fields })) as React.FC<any>;
};

export default getWidgetComponent;
